import { useEffect, useState, useCallback } from "react";
import { DOCS_DESKTOP_MIN_WIDTH } from "../pages/docs/config/docConstants";

export function useDocsMobileSidebar({ onAfterSelect } = {}) {
  const [mobileSidebarOpen, setMobileSidebarOpen] = useState(false);

  useEffect(() => {
    const onResize = () => {
      if (window.innerWidth >= DOCS_DESKTOP_MIN_WIDTH) {
        setMobileSidebarOpen(false);
      }
    };
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  const close = useCallback(() => setMobileSidebarOpen(false), []);
  const toggle = useCallback(() => setMobileSidebarOpen((open) => !open), []);

  const wrapSelect = useCallback(
    (selectFn) => (id) => {
      selectFn(id);
      setMobileSidebarOpen(false);
      onAfterSelect?.();
    },
    [onAfterSelect],
  );

  return { mobileSidebarOpen, close, toggle, wrapSelect };
}
